import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
import LoginLayout from "@/layout/dashboard/LoginLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import Notifications from "@/pages/Notifications.vue";
import Icons from "@/pages/Icons.vue";
import Maps from "@/pages/Maps.vue";
import Typography from "@/pages/Typography.vue";
import Clients from "@/pages/Clients.vue";
import Transaction from "@/pages/Transaction.vue";
import Reports from "@/pages/Report.vue";
import Services from "@/pages/Service.vue";
import Appointments from "@/pages/Appointment.vue";
import Transactions from "@/pages/Transactions.vue";
import Dtr from "@/pages/Dtr.vue";
import DtrManager from "@/pages/DtrManager.vue";
import DtrView from "@/pages/DtrView.vue";
import Expenses from "@/pages/Expenses.vue";

import AppointmentLayout from "@/layout/dashboard/AppointmentLayout.vue";
import RegisterClientLayout from "@/layout/dashboard/RegisterClientLayout.vue";
import TodaysAppointment from "@/layout/dashboard/TodaysAppointment.vue";


const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: {
          requiresAuth: true 
        }
      },
      {
        path: "clients",
        name: "clients",
        component: Clients,
        meta: {
          requiresAuth: true 
        }
      },
      {
        path: "transaction/:id",
        name: "transaction",
        component: Transaction,
        meta: {
          requiresAuth: true 
        }
      },
      {
        path: "appointments",
        name: "appointments",
        component: Appointments,
        meta: {
          requiresAuth: true 
        }
      },
      {
        path: "reports",
        name: "reports",
        component: Reports,
        meta: {
          requiresAuth: true,
          requiresAdmin: true  
        }
      },
      {
        path: "services",
        name: "services",
        component: Services,
        meta: {
          requiresAuth: true,
          requiresAdmin: true  
        }
      },
      {
        path: "transactions",
        name: "transactions",
        component: Transactions,
        meta: {
          requiresAuth: true 
        }
      },{
        path: "dtr",
        name: "dtr",
        component: Dtr,
        meta: {
          requiresAuth: true 
        }
      },{
        path: "dtr-manager",
        name: "dtr manager",
        component: DtrManager,
        meta: {
          requiresAuth: true,
          requiresAdmin: true   
        }
      },{
        path: "/dtr/:id",
        name: "dtr view",
        component: DtrView,
        meta: {
          requiresAuth: true,
          requiresAdmin: true   
        }
      },{
        path: "expenses",
        name: "expenses",
        component: Expenses,
        meta: {
          requiresAuth: true,
          requiresAdmin: true   
        }
      },
    ],
  },
  {
    path: "/login",
    component: LoginLayout,
    name: "login",

  },
  {
    path: "/appointment",
    component: AppointmentLayout,
    name: "appointment",

  },
  {
    path: "/reg",
    component: RegisterClientLayout,
    name: "registerclient",

  },
  {
    path: "/books",
    component: TodaysAppointment,
    name: "todaysappointment",

  },
  { path: "*", component: NotFound },
];



/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
